import { Column } from 'react-table';
import { useRecordTable } from '../../../hooks/useRecordTable';
import ImportTableHeader from './ImportTableHeader';
import ImportTableBody from './ImportTableBody';
import ImportTableFooter from './ImportTableFooter';
import TablePagination from '../base/TablePagination';
import clsx from 'clsx';
import { ImportProduct } from '../../../types/purchases/BasePurchase';
import { useMemo } from 'react';

export type ImportCustomColumn = Column<ImportProduct> & {
  customCell?: (cell: any) => JSX.Element | string;
  className?: string;
};

interface ImportRecordTableProps {
  columns: ImportCustomColumn[];
  data: ImportProduct[];
  actions?: any;
  pageSize?: number;
  noDataMessage?: string;
  tableHeaderContent?: React.ReactNode;
  maxWidth?: string;
}

const ImportRecordTable = ({
  columns,
  data,
  actions,
  pageSize = 10,
  noDataMessage = 'No hay registros de importación.',
  tableHeaderContent,
  maxWidth = 'max-w-6xl',
}: ImportRecordTableProps) => {
  const memoizedColumns = useMemo(() => columns, [columns]);
  const memoizedData = useMemo(() => data, [data]);

  const table = useRecordTable<ImportProduct>({
    columns: memoizedColumns,
    data: memoizedData,
    pageSize,
  });
  return (
    <div
      className={clsx(
        'mt-6 w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark',
        maxWidth
      )}
    >
      {/* Título y botón u otro contenido */}
      {tableHeaderContent && (
        <div className="mb-4 flex items-center justify-between px-4 pt-4">
          {tableHeaderContent}
        </div>
      )}

      {/* Tabla */}
      <section className="data-table-common data-table-two border-b border-t border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full overflow-x-auto p-2">
          <table
            {...table.getTableProps()}
            className="datatable-table min-w-[1500px] table-auto border-collapse break-words"
          >
            <ImportTableHeader
              table={table}
              showFilters={true}
              actions={actions}
            />
            <ImportTableBody
              table={table}
              actions={actions}
              noDataMessage={noDataMessage}
            />
            <ImportTableFooter data={table.memoizedData} actions={actions} />
          </table>
        </div>
        {/* Paginación */}
        <TablePagination table={table} />
      </section>
    </div>
  );
};

export default ImportRecordTable;
